import questions from './Testing_questions';
import api from '../../api/index';
import router from '../../router';

export default {
  namespaced: true,
  modules   : {
    questions,
  },
  state: {
    resultsLayout : false,
    passed_seconds: 0,
    timer_started : false,
    test_layout   : false,
    interval      : '',
    timer         : {},
  },
  getters: {
    resultsLayout        : ({resultsLayout}) => resultsLayout,
    test_layout          : ({test_layout}) => test_layout,
    passed_seconds       : ({passed_seconds}) => passed_seconds,
    get_course_name      : ({timer}) => timer.course,
    timer_started        : ({timer_started}) => timer_started,
    get_second_from_timer: ({timer}) => () => {
      let seconds_left = 0;

      if (!!Object.keys(timer).length) {
        let time = new Date(new Date(timer.time_end) - new Date());
        let minutes = new Date(time).getMinutes();
        let seconds = new Date(time).getSeconds();

        seconds_left = (minutes * 60) + seconds;
      }

      return seconds_left;
    },
  },
  mutations: {
    SET_STATE_TIME(state, payload) {
      state[payload.type] = payload.value;
    },
    ADD_SECOND(state) {
      state.passed_seconds += 1;
    },
    CLEAR_TIMER(state) {
      state.passed_seconds = 0;
    },
    START_TIMER(state) {
      state.timer_started = true;
    },
    SHOW_RESULTS(state) {
      state.resultsLayout = true;
    },
    HIDE_RESULTS(state) {
      state.resultsLayout = false;
    },
    ENABLE_TEST_LAYOUT(state) {
      state.test_layout = true;
    },
    DISABLE_TEST_LAYOUT(state) {
      state.test_layout = false;
    },
    TOGGLE_TEST_LAYOUT(state) {
      state.test_layout = !state.test_layout;
    },
  },
  actions: {
    killTimer({commit}) {
      commit('SET_STATE_TIME', {type: 'timer', value: {}});
      commit('course_info/DISABLE_SNACKBAR', {}, {root: true});
      localStorage.setItem('timer', null);
    },
    parseTimer({commit, dispatch, rootState}) {
      let timer = JSON.parse(localStorage.getItem('timer'));
      let user_id = rootState.autorisation.user_id;

      if (!!timer) {
        if (timer.time_end > new Date() && parseInt(user_id) === timer.user_id && !timer.interrupted) {
          commit('SET_STATE_TIME', {type: 'timer', value: timer});
          commit('course_info/ENABLE_SNACKBAR', {}, {root: true});
          commit('course_info/SET_STATE_COURSE', {type: 'interrupt_test', items: false}, {root: true});
        } else {
          dispatch('killTimer');
        }
      }
    },
    add_course_in_timer({commit, rootState}, course_id) {
      let user_id = rootState.autorisation.user_id;
      let obj_timer = {};

      let course_name = rootState.course_info.course_name;

      let course_time = rootState.course_info.time_test;
      let course_time_sec = rootState.course_info.test_remain_in_seconds;

      if (!course_id) {
        course_id = rootState.course_info.content.course_id;
      }

      obj_timer['course_id'] = parseInt(course_id);
      obj_timer['user_id'] = parseInt(user_id);

      obj_timer['timer_start'] = new Date();

      if (course_time_sec !== 0) {
        obj_timer['time_end'] = new Date().setSeconds(new Date().getSeconds() + course_time_sec);
      } else {
        obj_timer['time_end'] = new Date().setMinutes(new Date().getMinutes() + course_time);
      }

      obj_timer['course_time'] = course_time;
      obj_timer['course_name'] = course_name;

      obj_timer['interrupted'] = false;
      obj_timer['active'] = true;

      localStorage.setItem('timer', JSON.stringify(obj_timer));
      commit('SET_STATE_TIME', {type: 'timer', value: obj_timer || {}});
    },
    async interrupted_timer({commit, rootState, getters}, course_id) {
      if (!course_id) {
        course_id = rootState.course_info.content.course_id;
      }

      try {
        let remain_time = getters.get_second_from_timer();

        let timer = JSON.parse(localStorage.getItem('timer'));
        timer.interrupted = true;
        localStorage.setItem('timer', JSON.stringify(timer));
        commit('course_info/SET_STATE_COURSE', {type: 'interrupt_test', items: true}, {root: true});
        commit('course_info/UPDATE_REMAIN_COURSE', remain_time, {root: true});
      } catch (err) {
        console.error(err);
      }
    },

    async get_test_history({rootGetters, commit}, reset) {
      const course_id = rootGetters['course_info/content/course_id'];
      try {
        const test_id = await api.course.get_test_history(course_id);
        commit('testing/questions/SET_QUESTIONS', test_id.data.questions, {root: true});
        if (reset) {
          commit('testing/questions/RESET_HISTORY', {}, {root: true});
          commit('testing/questions/TO_QUESTION', 0, {root: true});
        } else {
          commit('testing/questions/SET_QUESTIONS_HISTORY', test_id.data.test_history, {root: true});
        }
      } catch (err) {
        console.error(err);
      }
    },
    async start_test({commit, rootGetters, dispatch}) {
      const course_id = rootGetters['course_info/content/course_id'];
      const course_name = rootGetters['course_info/course_name'];

      dispatch('get_test_history', 'reset');

      try {
        await api.course.test_start(course_id);
        await dispatch('course_info/get_course_by_id', course_id, {root: true});
        commit('CLEAR_TIMER');
        commit('HIDE_RESULTS');
        commit('course_info/SHOW_MOBILE', {}, {root: true});
        commit('course_info/SET_ACTIVE_COURSE', {id: course_id, name: course_name}, {root: true});
        commit('course_info/START_TEST', {}, {root: true});
        commit('ENABLE_TEST_LAYOUT');
        commit('course_info/modals/CLOSE_MODAL', 'test', {root: true});
        dispatch('timer');
      } catch (err) {
        console.error(err);
      }
    },
    async save_test_result({rootGetters, commit}) {
      let expired = rootGetters['course_info/expired'];
      let points_required_test    = rootGetters['course_info/points_required_test'];
      let test_result    = rootGetters['course_info/test_result'];
      const course_id = rootGetters['course_info/content/course_id'];
      const user    = rootGetters['profile/user/user'];
      let overdue = {
        'overdue': expired,
      };
      let course_info = {
        'course_id': Number(course_id),
        'user_id'  : Number(user.id),
      };
      try {
        let earned_points = await api.course.save_test_end(course_id, overdue);
        await commit('course_info/SET_EARNED_POINTS', earned_points.data.points, {root: true});
        await commit('course_info/SET_TEST_ATTEMPTS', earned_points.data.test_attempts, {root: true});
        await commit('course_info/SET_TEST_RESULT', earned_points.data.result, {root: true});
        if (test_result) {
          await api.course.finish_course(course_info);
        } else {
          commit('course_info/CANCEL_TEST', {}, {root: true});
        }
      } catch (err) {
        console.error(err);
      }
    },
    test_hide({commit}) {
      commit('DISABLE_TEST_LAYOUT');
      commit('course_info/TEST_HIDE', {}, {root: true});
    },
    async test_resume({commit, dispatch, rootGetters}, id) {
      if (id) {
        router.push({name: 'course_content', params: {id: id}});
        setTimeout(() => {
          dispatch('test_resume');
        });
      } else {
        await dispatch('get_test_history', false);
        let questions    = rootGetters['testing/questions/questions'];
        let test_history = rootGetters['testing/questions/test_history'];
        commit('course_info/modals/CLOSE_MODAL', 'test', {root: true});
        commit('course_info/steps/RESET_LESSONS', {}, {root: true});
        commit('course_info/SHOW_MOBILE', {}, {root: true});
        commit('course_info/DISABLE_SNACKBAR', {}, {root: true});

        let findQuestionId = 0;

        if (test_history) {
          findQuestionId = questions.findIndex((item, id)=>{
            return item.id == test_history[test_history.length-1].question_id;
          });
        }

        commit('testing/questions/TO_QUESTION', findQuestionId, {root: true});
        window.scrollTo(0, 0);
        commit('HIDE_RESULTS');
        commit('course_info/DISABLE_SNACKBAR', {}, {root: true});
        commit('course_info/TEST_NOT_FINISHED', {}, {root: true});
        commit('ENABLE_TEST_LAYOUT');
        commit('course_info/TEST_NOT_HIDDEN', {}, {root: true});
      }
    },
    test_cancel_modal({commit}) {
      commit('course_info/modals/OPEN_MODAL', 'test_cancel', {root: true});
    },
    test_cancel({commit, dispatch}) {
      // commit('course_info/CANCEL_TEST', {}, {root: true});
      commit('HIDE_RESULTS');
      commit('CLEAR_TIMER');
      dispatch('test_hide');
      commit('course_info/DISABLE_SNACKBAR', {}, {root: true});
      dispatch('testing/questions/resel_all', {}, {root: true});
      commit('course_info/modals/CLOSE_MODAL', 'test_cancel', {root: true});
    },
    async show_modal_results({commit, rootGetters, dispatch}) {
      await dispatch('save_test_result');
      commit('course_info/FINISH_TEST', {}, {root: true});
      await dispatch('profile/user/user_profile', {}, {root: true});
      let points_earned_test    = rootGetters['course_info/points_earned_test'];
      let points_required_test    = rootGetters['course_info/points_required_test'];
      let test_result    = rootGetters['course_info/test_result'];
      dispatch('get_test_history', false);
      if (test_result) {
        commit('course_info/modals/OPEN_MODAL', 'success', {root: true});
      } else {
        commit('course_info/modals/OPEN_MODAL', 'failed', {root: true});
      }
    },
    show_results({commit, rootGetters}) {
      window.scrollTo(0, 0);
      // dispatch('killTimer');
      commit('testing/questions/TO_QUESTION', 0, {root: true});
      commit('ENABLE_TEST_LAYOUT');
      commit('SHOW_RESULTS');
      commit('course_info/CANCEL_TEST', {}, {root: true});
      let points_earned_test    = rootGetters['course_info/points_earned_test'];
      let points_required_test    = rootGetters['course_info/points_required_test'];
      if (points_earned_test >= points_required_test) {
        commit('course_info/modals/CLOSE_MODAL', 'success', {root: true});
      } else {
        commit('course_info/modals/CLOSE_MODAL', 'failed', {root: true});
      }
    },
  },
};
